export default function (versions: Array<Object>) {
  return versions.reduce(
    (latestVersion, version) => (
      version.versionNumber > latestVersion.versionNumber ? version : latestVersion
    ), versions[0]) || {};
}
